module.exports = __webpack_public_path__ + "static/media/dxiconsmaterial.de33805c.ttf";